/**
 * Чистая реконсиляция смены индекса Embla → направление + покинутая карточка.
 * Покинутая карточка (items[prevIndex]) — та, которую юзер дочитал и свайпнул;
 * на forward именно её отмечаем seen.
 */
export function resolveIndexChange<T extends { id: string }>(
  items: T[],
  prevIndex: number,
  newIndex: number,
): { direction: 'up' | 'down'; leftCard: T } | null {
  if (newIndex === prevIndex) return null;
  const leftCard = items[prevIndex];
  if (!leftCard) return null;
  return { direction: newIndex > prevIndex ? 'up' : 'down', leftCard };
}
